import React from 'react';
import wizardMark from './assets/wizard20.png';

const Logo = () => (
  <div className="logo">
    <img src={wizardMark} alt="Free Thumbnail Wizard mascot" />
  </div>
);

export default Logo;
